export const CLIP = 'clip';
export const CLIPESODE = 'episode-clip';
export const EPISODE = 'episode';
export const MARATHON = 'marathon';
export const STREAM = 'stream';


// WEBPACK FOOTER //
// ./src/constants/video-type.js